var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "form-page client container-fluid broker-application-container",
    },
    [
      _c("application-notification-area", {
        attrs: {
          "application-id": _vm.applicationId,
          "client-username": _vm.clientUsername,
          "agent-username": _vm.agentUsername,
          "direct-to-lender-tab": _vm.directToLenderTab,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row justify-content-center h-100" }, [
        _c(
          "div",
          {
            staticClass:
              "col-12 form-page px-md-5 h-100 vertical-flex-container",
          },
          [
            _c(
              "application-header",
              _vm._b(
                {
                  attrs: {
                    loading: _vm.loadingApplicationHeader,
                    "application-info": _vm.CURRENT_APPLICATION,
                    "back-path": _vm.backPath,
                  },
                },
                "application-header",
                Object.assign({}, _vm.headerData, _vm.CURRENT_APPLICATION),
                false
              )
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "row no-gutters vertical-flex-fit overflow-hidden",
              },
              [
                _c("div", { staticClass: "col-xl-10 h-100" }, [
                  _c(
                    "div",
                    { staticClass: "h-100 vertical-flex-container" },
                    [
                      _c(
                        "div",
                        { staticClass: "vertical-flex-auto" },
                        [
                          _c("application-tabs", {
                            attrs: {
                              pages: _vm.pages,
                              "application-id": _vm.applicationId,
                              "client-username": _vm.clientUsername,
                              "agent-username": _vm.agentUsername,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "keep-alive",
                        { attrs: { include: "DirectToLenderContainer" } },
                        [
                          _vm.loading
                            ? _c("application-page-container-loader", {
                                attrs: { "current-page": _vm.currentPage },
                              })
                            : _c("router-view", {
                                key: _vm.$route.fullPath,
                                on: {
                                  "direct-to-lender-tab": _vm.handlePageChange,
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-2 col-3 pr-0 pl-sm-4 pl-0" },
                  [
                    !_vm.loading
                      ? _c("application-calculations", {
                          attrs: {
                            "application-id": _vm.applicationId,
                            "client-username": _vm.clientUsername,
                            "agent-username": _vm.agentUsername,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }